module.exports = __webpack_public_path__ + "img/icon-sort-1-up.fbb4d4b4.svg";